export default "__VITE_ASSET__c3509693__"